import BaseInfiniteLoader from "~/baseInfiniteLoader";
import InfiniteScrollLoader from "~/infiniteScrollLoader";
import ListViewProvider from "~/providers/listViewProvider";
import {Logger} from '~/services/logger'
import {Area} from "../../formability/modelViews/enums/area";

export default class ObjectModelEntriesInfiniteLoader extends BaseInfiniteLoader {
  _infiniteScrollLoader: InfiniteScrollLoader;

  constructor(listViewProvider?: ListViewProvider) {
    super();
    this._infiniteScrollLoader = <InfiniteScrollLoader>new InfiniteScrollLoader(function (requestData) {
      Logger.debug('ObjectModelEntriesInfiniteLoader', requestData.query, requestData.listView?.filterQuery)
      return new Promise((resolve, reject) => {
        if (requestData.listView) {
          const { listView, ...json } = requestData;

          listViewProvider.entries(listView, {...json, page: requestData.query.page})
            .then(response => {
              const result = response[0];
              resolve({result, objects: (result as any).entries});
            });
        } else if (import.meta.env.MODE === 'development') {
          throw new Error('List View not provided.');
        } else {
          resolve({result: {}, objects: []});
        }
      });
    });
  }
}
